import { slavtHTTP } from "../http";
import { Quiz } from "../../models/Quiz";
import { Paged } from "../../models/Paged";
import { Question } from "../../models/Question";
import { QuizSubmission } from "../../models/QuizSubmission";

export function getQuizDetails(quizId: string) {
  return slavtHTTP
    .get<Quiz>(`/quizzes/${quizId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createQuiz(quiz: Quiz) {
  return slavtHTTP
    .post<{ id: number }>(`/quizzes`, quiz)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editQuiz(exercise: Quiz) {
  return slavtHTTP
    .patch<{ id: number }>(`/quizzes/${exercise.id}`, exercise)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteQuiz(quizId: number) {
  return slavtHTTP
    .delete<void>(`/quizzes/${quizId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getQuizQuestions(quizId: number, page: number) {
  return slavtHTTP
    .get<Paged<Question>>(`/quizzes/${quizId}/questions?page=${page}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getQuizSubmissionDetails(quizId: number, submissionId: number) {
  return slavtHTTP
    .get<QuizSubmission>(`/quizzes/${quizId}/submissions/${submissionId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
